import React from "react";
import { useTranslation } from "react-i18next";

const KundliHeading = () => {
  const { t } = useTranslation();
  return (
    <div style={{ marginBottom: "4.5vw" }}>
      <h1 className="route-heading">{t("Kundli")}</h1>
      <p className="montserrat-font" style={{ textAlign: "justify" }}>
        {t("Kundli Heading")}
      </p>
    </div>
  );
};

export default KundliHeading;
